import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=18466544&scoped=true"
import script from "./chat.js?vue&type=script&lang=js&external"
export * from "./chat.js?vue&type=script&lang=js&external"
import style0 from "./chat.vue?vue&type=style&index=0&id=18466544&prod&lang=scss&scoped=true"
import style1 from "./chat.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18466544",
  null
  
)

export default component.exports